<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">Criar Pedido de Ativos</h4>
      </div>
      <div></div>

        <fg-input v-if="showMatriz" name="company" label="Empresa">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a empresa dos usuários"
            v-model="model.company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        <div class="col-sm-12" style="margin-left: -25px; margin-bottom: 20px">
          <label class="col-sm-6">Colaborador</label>
            <el-autocomplete
              class="select-default col-sm-12"
              v-model="colabName"
              :fetch-suggestions="querySearchAsync"
              placeholder="Comece a digitar para pesquisar"
              @select="handleSelect"
            ></el-autocomplete>

            <div class="text-danger invalid-feedback"
              ref="alertCustomer"
              style="display: none; margin-top: -5px">Campo obrigatório
            </div>

        </div>

        <fg-input
            name="machine"
            label="Máquina">
          <el-select
            size="large"
            placeholder="Selecione"
            v-model="model.vm"
            @input="checkType(model.vm)"
          >
            <el-option
              v-for="maq in machine"
              class="select-danger"
              :value="maq.id"
              :label="maq.location"
              :key="maq.id"
            ></el-option>
          </el-select>
          <div class="text-danger invalid-feedback"
            ref="alertType"
            style="display: none; margin-top: -5px">Campo obrigatório
          </div>
        </fg-input>

        <fg-input
            v-if="showAction"
            name="type"
            label="Tipo de ação">
          <el-select
            class="select-default"
            size="large"
            placeholder="Selecione um tipo"
            v-model="model.action_type"
          >
          
            <el-option
              v-for="option in tipo_acao"
              class="select-danger"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            ></el-option>
          </el-select>
          <div class="text-danger invalid-feedback"
            ref="alertValueType"
            style="display: none; margin-top: -5px">Campo obrigatório
          </div>
        </fg-input>

        <fg-input
            name="type"
            label="Selecione o produto">

          <el-select
            class="select-default"
            size="large"
            filterable
            @input="getControl(productSelet)"
            placeholder="Selecione um produto"
            v-model="productSelet"
          >
            <el-option
              v-for="option in productList"
              class="select-danger"
              :value="option.id"
              :label="option.control == null ? 'Produto:' + option.product_name  : 'Produto:' + option.product_name + ' - ' +' Status:' + option.control"
              :key="option.id"
            ></el-option> 
          </el-select>
          <div class="text-danger invalid-feedback"
            ref="alertProduct"
            style="display: none; margin-top: -5px">Campo obrigatório
          </div>
        </fg-input>
           
              <!-- :label="'Produto:' + option.product_name + '        Status:' + option.control " -->
        <fg-input
          v-if="!showAction"
          name="cota"
          label="Quantidade"
          onkeydown="javascript: return event.keyCode == 69 ? false : true"
          min="0"
          type='Number'
          v-validate="modelValidations.cota"
          v-model="model.quantity"
        ></fg-input>
       

        <!-- <fg-input
          name="name"
          label="Nome"
          v-validate="modelValidations.name"
          v-model="model.name"
          :error="getError('name')"
        ></fg-input> -->
        
    </card>
    <card>
      <div>
        <el-button type="primary" :loading="btnLoading" 
          @click.prevent="validate">Criar</el-button>
        <!-- <button type="submit"   class="btn btn-fill btn-info btn-wd">Salvar</button> -->
       
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option, Button, Upload, Dialog, Collapse, CollapseItem,
  Autocomplete, 
  Checkbox, 
  DatePicker,
  TimeSelect, } from "element-ui";
import swal from "sweetalert2";
import { Switch as LSwitch } from "src/components/index";
import { Validator } from "vee-validate";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Upload.name]: Upload,
    [Dialog.name]: Dialog,
    [Collapse.name]: Collapse,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CollapseItem.name]: CollapseItem,
    [DatePicker.name]: DatePicker,
    [Autocomplete.name]: Autocomplete,
    LSwitch
  },
  created() {
    this.crud = "Criar";
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.model.company = ciaID
      this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID})

    } else {
      this.$store.dispatch("products/list")
    }
    this.getListCompany()
  },
  computed: {
    products() {
      return this.$store.state.products.products;
    },
    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach === 'true') {
        return true
      } else {
        return false
      }
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
    machine() {
      return this.machines;
    },
  },
  data() {
    return {
      crud: "Criar",
      dialogImageUrl: "",
      companyList: [],
      vendMachine: [],
      colabName: '',
      productSelet: [],
      machines: [],
      selectMaq: [],
      productList: [],
      showAction: false,
      btnDissmiss: false,
      btnLoading: false,
      showPrices: false,

      tipo:[{label: 'Categoria', value: 'only_category'},
            {label: 'Produto', value: 'only_product'},
            {label: 'Toda empresa', value: 'total'}],

      tipo_acao:[{label: 'Retirada', value: 'R'},
            {label: 'Devolução', value: 'D'}],


      date: [],
      attributes: {
        type: [],
        value: []
      },
      model: {
        product: "",
        control: '',
      },
      modelValidations: {
        type: {
          required: true
        },
        category: {
          required: true
        },
        cota: {
          required: true,
        },
        valor_tipo: {
          required: true,
        },
        value: {
          required: true,
        }
      }
    };
  },
  mounted () {
    const ciaID = localStorage.getItem('smartmachCiaID')
    this.btnDissmiss = this.$store.state.general.permission.dismiss_new_product_dialog,
    this.$watch('model.type', () => {
      this.model.category = ''
      this.model.product = ''
      this.$refs.alertType.style.display = 'none'
    })
    if (ciaID) {
      this.$store.dispatch("machines/listSort",{sort: '?page_size=300'  + '&company=' + ciaID}).then(data =>{
        this.machines = data
        this.$store.dispatch('lockers/listSort', {sort: '?page_size=300'  + '&company=' + ciaID}).then(resp => {
          for (let index = 0; index < resp.length; index++) {
            this.machines.push(resp[index])
            console.log('machines', this.machines)
          }
        })
      })
    } else {
      this.$store.dispatch("machines/listSort",{sort: '?page_size=300'  + '&company=' + ''}).then(data =>{
        this.machines = data
        this.$store.dispatch('lockers/listSort', {sort: '?page_size=300'  + '&company=' + ''}).then(resp => {
          for (let index = 0; index < resp.length; index++) {
            this.machines.push(resp[index])
            console.log('machines', this.machines)
          }
        })
      })
    }
    this.$watch('model.company', ()=>{
      if (this.showMatriz) {
        this.getData()
      }
    })
    if(!this.showItem) {
      this.model.company = this.$store.state.auth.company
    } 
    
  }, 
  methods: {
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
      this.btnLoading = false
    },
    notifyError() {
      this.$notify({
        message: "Erro!</br>Item não salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
      this.btnLoading = false
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getData () {
      this.$store.dispatch("products/listSort",{sort: '?company=' + this.model.company})
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },

    querySearchAsync(queryString, cb) {
      var y
      this.$store.dispatch("customers/listSort", {sort: '?first_name__icontains=' + queryString}).then(data => {
        var x = data.map(v => {
          let value, link
          if (v.first_name) {
            value = v.first_name
          }
          link = value
          return {...v, value, link}
          
        })
        console.log('pesq', y)
        y = this.redux(x)
        this.links = y
        var links = this.links;
        var results
        
        results = queryString ? links.filter(this.createFilter(queryString)) : links;
      
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 600);
        })
    },

    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.colabName = item.first_name + ' ' + item.last_name
      this.model.customer = item.id
    },
    redux(x) {
      var seenNumber = {};

      var fil = x.filter(function(
        currentObject
      ) {
        if (currentObject.status in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.status] = true;
          return true;
        }
      });
      return fil;
    },
    checkType (data) {
      console.log('type', data)
      var type = Number
      this.machine.filter(v =>{
        if (v.id == data) {
          type = v.type
        }
      })
      console.log('ty', type)
      if (type == 1) {
        this.showAction = true
        this.model.quantity = 1
      } else {
        this.showAction = false
      }
      this.getItens (type, data)
    },

    getItens (type, data) {
      if (type == 0) {
        this.$store.dispatch('stock/listSort',{sort: '?page_size=200&shelf__vm='+ data}).then(resp =>{
          console.log('resp', resp)
          this.productList = resp.filter((value, index, self) =>
            index === self.findIndex((t) => (
              t.product === value.product && t.product_name === value.product_name && t.product != null
            ))
          ) 

          console.log('list', this.productList)
        })
      } else {
        this.$store.dispatch("boxes/listSort", {sort: '?shelf__vm=' + 
          data + '&ordering=id' + '&page_size=161'}).then(resp =>{
            this.productList = resp.filter((value, index, self) =>
              index === self.findIndex((t) => (
                t.product === value.product && t.product_name === value.product_name && t.product != null && t.control === value.control
              ))
            ) 

          console.log('list', this.productList)
          })

      }
    },

    getControl (id) {
      this.productList.filter(v =>{
        if (v.id == id) {
          this.model.control = v.control
          this.model.product = v.product
        }
      })
    },

    validate() {
      console.log('calid', this.$validator)
      console.log('model', this.model)
      this.$validator.validateAll().then(isValid => {
        if (this.model.product === '') {
          this.$refs.alertProduct.style.display = 'block'
          isValid = false
        }
        if (this.colabName == '') {
          this.$refs.alertCustomer.style.display = 'block'
          isValid = false
        }
        if (!this.showAction) {
          this.model.action_type = 'R'
        }
        // if (this.model.customer == ''){
        //   this.$refs.alertProduct.style.display = 'block'
        //   isValid = false
        if (isValid) {
          this.btnLoading = true
          this.$store.dispatch('ownOrder/create', {item: this.model}).then(resp => {
            console.log('respos', resp)
            this.btnLoading = false
            this.notifySuccess();
            this.$router.push(`/app/sales/pedidosSistema/`)
          })
        }
      });
    },
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
.label-add {
  margin-top: 20px;
}
.div-img {
  padding: 15px;
  display: inline-block;
}
.remove-attribute {
  padding: 1px;
  margin-top: 30px;
}
#linha {
  width: 100%;
  border-bottom: 1px solid #c5c0c0;
}
</style>
